import {Container, Paper} from "@mui/material";
import React from "react";

// @ts-ignore
function View({children}) {

    return (
        <Container maxWidth="sm">
            <Paper sx={{p: 2, mt: 2}} elevation={4}>
                {children}
            </Paper>
        </Container>
    )
}

export default View;